import { useLanguages } from 'core/hooks/languages';
import { useSaveLanguage } from 'core/hooks/settings/language';
import { i18n, resolveSupported } from 'core/i18n';
import { useState } from 'react';
import { toLanguageText } from './language-selector.business';

export const useLanguageSelector = () => {
  const { languages } = useLanguages();
  const { saveLanguage, isSavingLanguage } = useSaveLanguage();
  const [visible, setVisible] = useState(false);

  const currentLanguage = resolveSupported(i18n.language);
  const currentLanguageText = toLanguageText(languages, currentLanguage);

  const toggle = () => {
    if (!isSavingLanguage) {
      setVisible(previous => !previous);
    }
  };

  const close = () => setVisible(false);

  const select = (value: string) => {
    setVisible(false);
    if (value === currentLanguage) {
      return;
    }
    const previousLanguage = currentLanguage;
    void i18n.changeLanguage(value);
    saveLanguage(value, {
      onError: () => {
        void i18n.changeLanguage(previousLanguage);
      },
    });
  };

  return {
    languages,
    currentLanguage,
    currentLanguageText,
    isSavingLanguage,
    visible,
    setVisible,
    toggle,
    close,
    select,
  };
};
